import { createApp } from 'vue'
import App from './App.vue'
import './assets/style.css'
import './assets/global.css'
createApp(App).mount('#app')
